import { gbConstants } from "../_constants";
import { authHeader } from "../_helpers";

export const campaignService = {
    getAll,
    signUp,
    createCampaign,
    updateCampaignState,
    updateCampaign,
    uploadBanner,
    removeBanner,
    deleteCampaign,
    resumeCampaignState,
    getCampaignDetail,
    updateCampaigns,
};
const campaignURL = `${gbConstants.HOST_SERVICE}/v1.1/campaigns`;
const campaignSignUpURL = `${gbConstants.HOST_SERVICE}/v1.1/campaigns/signup`;
const createCampaignURL = `${gbConstants.HOST_SERVICE}/v1.1/save-campaign`;
const updateCampaignStateURL = `${gbConstants.HOST_SERVICE}/v1.1/campaign`;
const resumeCampaignStateURL = `${gbConstants.HOST_SERVICE}/v1.1/resume`;
const uploadBannerURL = `${gbConstants.HOST_SERVICE}/v1.1/upload`;
const removeBannerURL = `${gbConstants.HOST_SERVICE}/v1.1/remove`;
const deleteCampaignURL = `${gbConstants.HOST_SERVICE}/v1.1/campaign`;
const campaignDetailURL = `${gbConstants.HOST_SERVICE}/v1.1/campaign`;
const updateCampaignsURL = `${gbConstants.HOST_SERVICE}/v1.1/updates`;

function getAll() {
    const requestOptions = {
        mode: "cors",
        method: "GET",
        headers: authHeader()
    };

    return fetch(campaignURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }
            return data;
        });
}

function signUp(driverId, campaignId, campaignName) {
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ driverId, campaignId, campaignName })
    };

    return fetch(campaignSignUpURL, requestOptions).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json();
    });
}

function uploadBanner(image) {
    let data = new FormData();
    data.append("file", image);
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: data
    };

    return fetch(uploadBannerURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            if (
                data.thumbnail_small == null ||
                data.thumbnail_medium == null ||
                data.url == null
            ) {
                return Promise.reject("Some images are not created");
            }
            return data;
        });
}
function removeBanner(imageUrl) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({imageUrl}),
    };
    return fetch(removeBannerURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            console.log(data)
        });
}
function createCampaign(campaign) {
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(campaign)
    };

    return fetch(createCampaignURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }

            return data.data;
        });
}

function resumeCampaignState(campaignId) {
    const requestOptions = {
        method: "PATCH",
        headers: authHeader()
    };
    let url = `${resumeCampaignStateURL}/${campaignId}`;

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }
            return data;
        });
}

function updateCampaignState(campaignId, newStateId) {
    const requestOptions = {
        method: "PATCH",
        headers: authHeader()
    };

    let url = `${updateCampaignStateURL}/${campaignId}/${newStateId}`;

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }

            return data;
        });
}

function updateCampaign(campaignId, campaignData) {
    // Create campaign object with id & data
    let campaign = { id: campaignId, ...campaignData };

    // Request
    const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(campaign)
    };

    return fetch(createCampaignURL, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }

            return data.data;
        });
}

function deleteCampaign(campaignId) {
    const requestOptions = {
        method: "DELETE",
        headers: authHeader()
    };

    let url = `${deleteCampaignURL}/${campaignId}`;

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }

            return response.json();
        })
        .then(data => {
            if (
                data.error &&
                data.error.code &&
                data.error.code !== 200 &&
                data.error.message
            ) {
                return Promise.reject(data.error.message);
            }

            return data;
        });
}

function getCampaignDetail(campaignId) {
    const requestOptions = {
        mode: "cors",
        method: "GET",
        headers: authHeader()
    };

    let url = `${campaignDetailURL}/${campaignId}`;

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            return data;
        });
}

function updateCampaigns() {
    const requestOptions = {
        mode: "cors",
        method: "GET",
        headers: authHeader()
    };

    let url = `${updateCampaignsURL}`;

    return fetch(url, requestOptions)
        .then(response => {
            if (!response.ok) {
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(data => {
            return data;
        });
}


// WEBPACK FOOTER //
// ./src/_services/campaign.service.js